/** 1px slop so sub-pixel rounding doesn't falsely trigger marquee. */
export const OVERFLOW_TOLERANCE_PX = 1;

/** True when measured content is wider than its container. */
export function textOverflowsContainer(
  contentWidth: number,
  containerWidth: number,
  tolerancePx: number = OVERFLOW_TOLERANCE_PX
): boolean {
  if (!Number.isFinite(contentWidth) || !Number.isFinite(containerWidth)) return false;
  if (containerWidth <= 0) return false;
  return contentWidth > containerWidth + tolerancePx;
}

/**
 * Whether the marquee animation should run.
 * Requires overflow, on-screen visibility, and no prefers-reduced-motion.
 */
export function shouldAnimateMarquee(opts: {
  overflows: boolean;
  isVisible: boolean;
  prefersReducedMotion: boolean;
}): boolean {
  return Boolean(opts.overflows && opts.isVisible && !opts.prefersReducedMotion);
}

export function getPrefersReducedMotion(
  matchMediaFn?: ((query: string) => MediaQueryList) | undefined
): boolean {
  const mq =
    matchMediaFn ||
    (typeof window !== 'undefined' && typeof window.matchMedia === 'function'
      ? window.matchMedia.bind(window)
      : undefined);
  try {
    return Boolean(mq?.('(prefers-reduced-motion: reduce)')?.matches);
  } catch {
    return false;
  }
}
